import React from "react";
import { Col, Row } from "react-bootstrap";
import { FiArrowRight } from "react-icons/fi";

const SkillCard = ({ icon, title, onClick }) => {
  return (
    <Row>
      <Col xs={12} sm={6} md={4} lg={3} xl={2}>
      <div className="skill-card-parent">
        <div className="skill-card" onClick={onClick}>
          <div className="icon-container">
            <img src={icon} alt={`${title} icon`} />
          </div>
          <h3 className="skill-title">{title}</h3>
          <div className="hover-arrow">
            <FiArrowRight />
          </div>
        </div>
        </div>
      </Col>
    </Row>
  );
};

export default SkillCard;
